<template>
  <v-row dense>
    <v-col cols="12" :sm="fullWidth ? '12' : '3'">
    <span class="caption font-weight-bold">Classe financeira</span>
    <div :class="`${textClass}`">
      {{ formData.CONTA_FINANCEIRA | truncate(45) }}
    </div>
    </v-col>
    <v-col cols="12" :sm="fullWidth ? '12' : '3'">
      <span class="caption font-weight-bold">Operação</span>
      <div :class="`${textClass}`">
        {{ formData.OPERACAO | truncate(45) }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    textClass: {
      type: String,
      default: '',
    },
  },
};
</script>
